import { useCallback, useState } from "react";

export interface UseBulkActionsProps<T = unknown> {
  selected?: T[];
}

export interface UseBulkActionsResult<T = unknown> {
  selected: T[];
  onSelect: (selected: T[]) => void;
}

export const useBulkActions = (props: UseBulkActionsProps = {}): UseBulkActionsResult => {
  const [selected, setSelected] = useState<unknown[]>(() => props.selected || []);

  const onSelect: UseBulkActionsResult["onSelect"] = useCallback((result) => {
    setSelected(result);
  }, []);

  return {
    selected,
    onSelect,
  };
};
